define('OutSystems/ClientRuntime/ScreenStateCache',["require", "exports", "./Logger", "./ObjectExtensions", "./RolesInfo", "./Settings"], function (require, exports, Logger, ObjectExtensions, RolesInfo_1, Settings_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ScreenStateCache = void 0;
    var ScreenStateCache = (function () {
        function ScreenStateCache() {
        }
        ScreenStateCache.addKey = function (stateCacheKey) {
            this.cache[stateCacheKey] = {
                components: {},
            };
            this.cacheKeys.push(stateCacheKey);
            var deltaToRemove = this.cacheKeys.length - ScreenStateCache.MaxCacheSize;
            if (deltaToRemove > 0) {
                for (var i = 0; i < deltaToRemove; i++) {
                    this.removeKey(this.cacheKeys[i]);
                }
            }
        };
        ScreenStateCache.removeKey = function (stateCacheKey) {
            delete this.cache[stateCacheKey];
            this.cacheKeys.splice(this.cacheKeys.indexOf(stateCacheKey), 1);
        };
        ScreenStateCache.save = function (stateCacheKey, componentKey, state, customProperties) {
            if ((0, Settings_1.getEnvParams)().ClearScreenStateCacheOnSessionChange && this.skipNextCacheSaves) {
                Logger.trace(this, function () { return "Skipping screen component save to cache."; });
                return;
            }
            if (!this.cache[stateCacheKey]) {
                this.addKey(stateCacheKey);
            }
            this.cache[stateCacheKey].components[componentKey] = {
                state: state,
                customProperties: customProperties,
            };
        };
        ScreenStateCache.load = function (stateCacheKey, componentKey) {
            var screenState = ScreenStateCache.loadScreenCache(stateCacheKey);
            return screenState ? screenState.components[componentKey] : null;
        };
        ScreenStateCache.loadScreenCache = function (stateCacheKey) {
            return this.cache[stateCacheKey] || undefined;
        };
        ScreenStateCache.clear = function (stateCacheKey) {
            var _this = this;
            if (!stateCacheKey) {
                this.cache = {};
                this.cacheKeys = [];
            }
            else if (this.cache[stateCacheKey]) {
                this.removeKey(stateCacheKey);
            }
            Logger.trace(this, function () {
                return "State cache contains ".concat(Object.keys(_this.cache).length, " entries with a total size of ").concat(ObjectExtensions.roughSizeOf(_this.cache), " bytes");
            });
        };
        ScreenStateCache.inspect = function () {
            return {
                cache: this.cache,
                cacheKeys: this.cacheKeys,
            };
        };
        ScreenStateCache.clearCacheIfUserChanged = function () {
            var _this = this;
            var currentUserId = (0, RolesInfo_1.getUserId)();
            this.skipNextCacheSaves = false;
            if (this.lastKnownUserId === currentUserId) {
                return;
            }
            if (this.lastKnownUserId !== 0) {
                Logger.trace(this, function () { return "Clearing screen cache."; });
                this.clear();
                this.skipNextCacheSaves = true;
            }
            Logger.trace(this, function () { return "User ID changed from ".concat(_this.lastKnownUserId, " to ").concat(currentUserId, "."); });
            this.lastKnownUserId = currentUserId;
        };
        ScreenStateCache.MaxCacheSize = 20;
        ScreenStateCache.cache = {};
        ScreenStateCache.cacheKeys = [];
        ScreenStateCache.lastKnownUserId = (0, RolesInfo_1.getUserId)();
        ScreenStateCache.skipNextCacheSaves = false;
        return ScreenStateCache;
    }());
    exports.ScreenStateCache = ScreenStateCache;
});
//# sourceMappingURL=ScreenStateCache.js.map;
